export const PHOENIX_DEALER_CONTEXT_CHANNEL = 'phoenix-dealer-context';

export const PHOENIX_DEALER_CONTEXT_CHANGED = 'PHOENIX_DEALER_CONTEXT_CHANGED';

export interface DealerContextSnapshot {
  cmsDealerNumber: string;
  dealerId: number;
}

export interface DealerContextChangedMessage extends DealerContextSnapshot {
  type: typeof PHOENIX_DEALER_CONTEXT_CHANGED;
}
